 // Copyright (c) 2016 Deere & Company

 import './modal-body.scss';
 import React, {PropTypes} from 'react';
 import Dropdown from '../dropdown';
 import {FormattedMessage} from 'react-intl';
 import InputField from '../input-field';
 import KeyValuePairCollection from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
 import TransferEnterAor from '@deere/cps-it.warranty-model-factory/lib/transfer-enter-aor';
 import {WarrantySimpleModal} from '../../../../shared/components/modal';

 const TransferModal = props =>
     <section className='reject-confirmation-modal'>
         <WarrantySimpleModal isOpen={props.isOpen}>
             <header>
                 <FormattedMessage id={props.title}/>
                 <div className='button-group'>
                     <button onClick={props.onClose}>
                         <FormattedMessage id='CANCEL'/>
                     </button>
                     <button
                         className='button-primary'
                         disabled={props.transfer.rejectReason === '' && true}
                         onClick={props.onConfirm}
                     >
                         <FormattedMessage id='CONFIRM'/>
                     </button>
                 </div>
             </header>
             <div className='reject-modal-body'>
                 <div className='modal-popup'>
                     <span className='data-label'>
                         <sup></sup><FormattedMessage id='REASON_FOR_TRANSFER_REJECTION'/>
                     </span>
                     <Dropdown
                         data={props.rejectedResons}
                         name='transferRejectionReason'
                         onItemChange={props.onRejectReasonChange}
                         text=''
                         value=''
                     />
                     {props.isRejectReasonOther &&
                     <InputField
                         label='COMMENTS'
                         onInputChange={props.onRejectedReasonInputChange}
                         propertyToUpdate='postalTrackingNumber'
                     />
                     }
                 </div>
             </div>
         </WarrantySimpleModal>
     </section>;

 TransferModal.displayName = 'TransferModal';
 TransferModal.propTypes = {
     isOpen: PropTypes.bool.isRequired,
     isRejectReasonOther: PropTypes.bool.isRequired,
     onClose: PropTypes.func.isRequired,
     onConfirm: PropTypes.func.isRequired,
     onRejectReasonChange: PropTypes.func.isRequired,
     onRejectedReasonInputChange: PropTypes.func.isRequired,
     rejectedResons: PropTypes.instanceOf(KeyValuePairCollection).isRequired,
     title: PropTypes.string.isRequired,
     transfer: PropTypes.instanceOf(TransferEnterAor).isRequired
 };

 export default TransferModal;




// WEBPACK FOOTER //
// ./src/product/transfers/components/modal/index.js